import { render } from "./DeleteModuleModal.vue?vue&type=template&id=2c4f071e&scoped=true&ts=true"
import script from "./DeleteModuleModal.vue?vue&type=script&lang=ts"
export * from "./DeleteModuleModal.vue?vue&type=script&lang=ts"

import "./DeleteModuleModal.vue?vue&type=style&index=0&id=2c4f071e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4f071e"]])

export default __exports__